import { HTMLContent } from '@yimoka/antd';
import DOMPurify from 'dompurify';

/** SafeHTMLContent 在官网公开渲染边界净化富文本，避免基础组件的原始 HTML 能力绕过 Profile 校验。 */
export function SafeHTMLContent({ value = '', ...props }: Record<string, unknown>) {
  const safeValue = typeof value === 'string' ? DOMPurify.sanitize(value) : '';
  return <HTMLContent {...props} value={safeValue} />;
}
